module.exports = __webpack_public_path__ + "static/media/photo299.f3f14171.jpg";